import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

// Значения фильтров сводного отчета -> query string (массивы через запятую)
export const buildReportSummaryParams = (selectors) => {
  const params = new URLSearchParams();

  Object.entries(selectors).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      params.append(key, value.join(','));
    } else if (value !== undefined && value !== null) {
      params.append(key, value);
    }
  });

  return params.toString();
};

export const fetchReportSummary = (searchParams) =>
  getNetwork().get(`${API_ROOT}/edu-report/consolidated?${searchParams}`);

// Excel свода по мероприятиям собирает бек, параметры те же, что у /edu-report/consolidated
export const fetchReportSummaryExport = (searchParams) =>
  getNetwork().get(`${API_ROOT}/edu-report/consolidated/export?${searchParams}`, { responseType: 'blob' });
